import type { LC_MonthlyCutYearItemOut, MonthlyCutYearItem } from './monthlyCutsYears.types';


export function mapMonthlyCutYearItem(item: LC_MonthlyCutYearItemOut): MonthlyCutYearItem {
  return {
    year: item.year,
    description: item.description,
  };
}

export function mapMonthlyCutYearItemToOption(
  item: MonthlyCutYearItem,
): { value: string; label: string } {
  return {
    value: String(item.year),
    label: String(item.year),
  };
}
